import type { Action } from "../../actions/types";

export type StoreState = string | null;

export const initialState = null;

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  if (action.type === "SET_WIDGET_CONFIG_ID") {
    return action.data;
  }

  return state;
}
